<template>
  <div class="header">
    
    <div style="display:flex;">
      <div class="bloco" @click="$store.dispatch('updateCalendarioCompleto',false)" :style="{'background': !$store.getters.calendarioCompleto ? '#1d3b53' : '','color': !$store.getters.calendarioCompleto ? '#fff' : ''}">
        Calendario Resumido
      </div>
      <div class="bloco"  @click=" $store.dispatch('updateCalendarioCompleto',true)" :style="{'background': $store.getters.calendarioCompleto ? '#1d3b53' : '','color': $store.getters.calendarioCompleto ? '#fff' : ''}">
        Calendario Completo
      </div>
       <div class="bloco" @click="imprimir" >
        Imprimir
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods:{    
    imprimir(){
      let conteudo = document.querySelector('.content').innerHTML
       

window.document.write(`<html> 
              <style> 
              td, th {
                  border: 1px solid #dddddd;
                  text-align: left;
                  padding: 8px;
                  font-size:14px;
              }
              p{
                font-size:14px;
              }
              table {
                  font-family: arial, sans-serif;
                  border-collapse: collapse;
                  width: 100%;
              }
              </style>
        <body>
          ${ conteudo}
        </body>
      </html>` );
      window.window.print();
      window.window.close();
    }
  }
}
</script>

<style>
.header{
    grid-area: header;
    background: #fff;
    border-bottom: 1px solid #d8dce5;
    box-shadow: 0 1px 4px rgb(0 21 41 / 8%);
    display: flex;
    align-items: center;
    justify-content: flex-start;
   
}
.header .bloco{
      border: 1px solid #1d3b53;
       transition: 0.5s ease-out;
    padding: 5px;
    cursor: pointer;
    display: flex;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    margin-left: 20px;
    border: 1px solid rgb(174 174 174);
}
.header .bloco:hover{
  background: #1d3b53;
  color:#fff;
}
</style>